const STALE_ASSET_RELOAD_KEY = 'tpge-stale-asset-reload';

export function isStaleAssetError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : String(error ?? '');

  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /Loading chunk [\d]+ failed/i.test(message)
  );
}

export async function recoverFromStaleAssets(): Promise<void> {
  if (sessionStorage.getItem(STALE_ASSET_RELOAD_KEY)) return;
  sessionStorage.setItem(STALE_ASSET_RELOAD_KEY, '1');

  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    if ('caches' in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }
  } catch (err) {
    console.error('Failed to clear stale app cache', err);
  }

  window.location.reload();
}
